<template>
  <div ref="container" class="tradingview-widget-container">
    <div class="tradingview-widget-container__widget"></div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const container = ref(null);

onMounted(() => {
  if (!container.value) return;

  const script = document.createElement('script');
  script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js';
  script.async = true; // 비동기 로드 (메인 스레드 차단 방지)
  script.innerHTML = JSON.stringify({
    symbols: [
      { description: "BTCUSDT", proName: "BINANCE:BTCUSD" },
      { description: "ETHUSDT", proName: "BINANCE:ETHUSD" },
      { description: "XRPUSDT", proName: "BINANCE:XRPUSD" },
      { description: "SOLUSDT", proName: "BINANCE:SOLUSD" },
      { description: "ADAUSDT", proName: "BINANCE:ADAUSD" },
      { description: "DOGEUSDT", proName: "BINANCE:DOGEUSD" }
    ],
    showSymbolLogo: true,
    isTransparent: true, // 배경 투명하게 처리 (디자인 융화)
    displayMode: "compact",
    colorTheme: "dark",
    locale: "en"
  });

  container.value.appendChild(script);
});
</script>

<style scoped>
/* 필요하다면 위젯 컨테이너 스타일링 추가 */
.tradingview-widget-container {
  width: 100%;
}
</style>